export default {
  title: 'Edit project',
  backButton: 'All projects',
};
